import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SidenavService } from './core/services/sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { appMenu } from './config/menu.config';
import { ApiService } from './core/services/api.service';
import { AuthService } from './core/services/auth.service';
import { SignalStore } from './shared/functions/store.functions';
import { AppState } from './core/models/app.model';
import { ChildrenOutletContexts } from '@angular/router';
import { slideInAnimation } from './animations';
import { RoutingService } from './core/services/routing.service';
import { Title } from '@angular/platform-browser';
import { ScreenService } from './core/services/screen.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {
  isMobile = this.screen.isMobile;
  isCollapsed = true;
  readonly title = this.appStore.select(state => state.name);
  readonly version = this.appStore.select(state => state.version);
  readonly author = this.appStore.select(state => state.author);
  readonly logo = this.appStore.select(state => state.logo);
  @ViewChild('leftPanel', {static: true}) private leftPanel?: MatSidenav;
  @ViewChild('rightPanel', {static: true}) private rightPanel?: MatSidenav;
  readonly showTitle = this.appStore.select(state => state.header.showTitle);
  readonly showLogo = this.appStore.select(state => state.header.showLogo);

  constructor(
    @Inject('app-store') private readonly appStore: SignalStore<AppState>,
    public sidenavService: SidenavService,
    public apiService: ApiService,
    private readonly authService: AuthService,
    private contexts: ChildrenOutletContexts,
    private routingService: RoutingService,
    private readonly titleService: Title,
    private readonly screen: ScreenService,
  ) {
    this.titleService.setTitle(this.appStore.state().name);
  }

  ngOnInit() {
    this.sidenavService.leftSidenav = this.leftPanel;
    this.sidenavService.rightSidenav = this.rightPanel;
  }

  isLoggedIn() {
    return this.authService.isAuthenticated();
  }
  isSetRole() {
    return this.authService.isSetUser();
  }

  appMenu() {
    return appMenu;
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

  getPageTitle() {
    return this.routingService.getCurrentMenuItem()?.label;
  }

  getPageIcon() {
    return this.routingService.getCurrentMenuItem()?.icon;
  }
}
